import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {GenericLinkedResource} from '@catcore/types/base';
import {extractDataFromProperty} from '@catcore/utils';
import {StatusInfo} from '@catfeatures/types';
import {FeatureUnit, FeatureUnitCreateInfo} from '@catmodules/models/feature-units/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

/**
 * Service to manage all aspects around one or many FeatureUnit models
 */
@Injectable()
export class FeatureUnitsService extends RestHttpService<StatusInfo> {

  constructor(service: Restangular) {
    super('feature-units', service);
  }

  /**
   * Initiates the process to create a single FeatureUnit through the WebAPI
   * @param {FeatureUnitCreateInfo} item
   * @returns {Observable<any>}
   */
  create(item: FeatureUnitCreateInfo): Observable<any> {
    return this.queryAll()
      .post({
        model: item.unit._links.self.href,
        update_group: item.updateGroup,
        featureType: item.featureType._links.self.href,
        virtual: item.isVirtual,
      })
      .map((createdFeature) => {
        return createdFeature;
      });
  }

  /**
   * Returns all available Services for a FeatureUnit as dumb simple GenericLinkedResource
   * @param {FeatureUnit} featureUnit
   * @returns {GenericLinkedResource[]}
   */
  extractServicesFor(featureUnit: FeatureUnit): GenericLinkedResource[] {
    const lookupKey = 'service_types';
    return extractDataFromProperty(featureUnit, lookupKey);
  }

  /**
   * Returns all available Parameters for a FeatureUnit as dumb simple GenericLinkedResource
   * @param {FeatureUnit} featureUnit
   * @returns {GenericLinkedResource[]}
   */
  extractParametersFor(featureUnit: FeatureUnit): GenericLinkedResource[] {
    const lookupKey = 'parameters';
    return extractDataFromProperty(featureUnit, lookupKey);
  }

  /**
   * Updates the feature unit from the underlying model.
   * @param id
   */
  updateFromModel(id: any) {
    return this.getRawSubresource(id, 'update');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/feature-units/services/feature-units.service.ts